import React from 'react'
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material'
import { USAGE_TYPES } from '../../constants'

export interface SegmentFieldsProps {
  segment: any
  readonly?: boolean
  onFieldChange: (field: string, value: any) => void
  showId?: boolean
  showName?: boolean
  showUsage?: boolean
  showMaxUse?: boolean
}

const SegmentFields = React.memo<SegmentFieldsProps>(
  ({
    segment,
    readonly = false,
    onFieldChange,
    showId = true,
    showName = true,
    showUsage = true,
    showMaxUse = true,
  }) => {
    return (
      <Grid container spacing={1} alignItems="center">
        {showId && (
          <Grid item xs="auto">
            <TextField
              label="ID"
              value={segment.id || ''}
              onChange={e => onFieldChange('id', e.target.value)}
              disabled={readonly}
              size="small"
              sx={{ minWidth: 90 }}
            />
          </Grid>
        )}
        {showName && (
          <Grid item xs>
            <TextField
              fullWidth
              label="Name"
              value={segment.name || ''}
              onChange={e => onFieldChange('name', e.target.value)}
              disabled={readonly}
              size="small"
            />
          </Grid>
        )}
        {showUsage && (
          <Grid item xs="auto">
            <FormControl size="small" sx={{ minWidth: 120 }}>
              <InputLabel id="segment-usage-label">Usage</InputLabel>
              <Select
                labelId="segment-usage-label"
                value={segment.usage || 'M'}
                onChange={e => onFieldChange('usage', e.target.value)}
                disabled={readonly}
                label="Usage"
              >
                {USAGE_TYPES.map(type => (
                  <MenuItem key={type.value} value={type.value}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}
        {showMaxUse && (
          <Grid item xs="auto">
            <TextField
              label="Max Use"
              value={segment.max_use || ''}
              onChange={e => onFieldChange('max_use', e.target.value)}
              disabled={readonly}
              size="small"
              sx={{ minWidth: 90 }}
            />
          </Grid>
        )}
      </Grid>
    )
  }
)

SegmentFields.displayName = 'SegmentFields'

export default SegmentFields
